import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { CalendarSyncSettingsEffects } from './calendar-sync-settings.effects';

// @dynamic
@NgModule({
  imports: [EffectsModule.forFeature([CalendarSyncSettingsEffects])]
})
export class CalendarSyncSettingsLazyModule {}
